import styled from "styled-components";

export const GovtBusContainer = styled.section`
  margin-bottom: 7rem;
  width: 100%;
`;

export const BusHeading = styled.h2`
  font-family: Quicksand;
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  color: #141823;
  margin-bottom: 16px;
`;

export const GovtBusWrapper = styled.div`
  background: #fff;
  border-radius: 4px;
  padding: 1rem 1.5rem;
`;

export const BusContainer = styled.div`
  display: flex !important;
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const BusImgContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const BusImgWrap = styled.div`
  width: 44px;
  height: 44px;
  padding: 6px;
  border-radius: 22px;
  background: #ffffff;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.11);
`;

export const BusImg = styled.img`
  width: 100%;
  height: 100%;
`;

export const BusTxtWrap = styled.p`
  background: #ffffff;
  padding: 2px 4px;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.11);
  border-radius: 2px;
  margin-top: -4px;
`;

export const BusTxt = styled.p`
  font-family: Quicksand;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #141823;
`;

export const BusName = styled.p`
  font-family: Roboto;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  color: #141823;
  width: 110px;
  white-space: normal;
  margin-top: 16px;
`;
